var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0C13.2187 10.858 0 23.5731 0 35.115C0 46.6568 12.321 56 27.5 56C42.679 56 55 46.656 55 35.115C55 23.5739 41.7819 10.859 27.5 0V0ZM10.3457 33.1334C11.0253 33.0574 11.7151 33.2172 12.1954 33.5605C12.6749 33.9039 12.8852 34.3891 12.7583 34.8599C11.8472 38.8158 15.7597 43.8739 20.1287 45.9122H20.1295C20.6009 46.1286 20.93 46.4663 21.0428 46.8518C21.1565 47.2367 21.0443 47.6376 20.7322 47.9655C20.4202 48.2929 19.9332 48.5206 19.3799 48.5977C18.8265 48.6748 18.251 48.5951 17.7826 48.3762C11.864 45.6152 7.29781 39.8613 8.561 34.3765C8.69675 33.733 9.422 33.2278 10.3457 33.1332L10.3457 33.1334Z",
    fill: "#88ABFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWather);
export default __webpack_public_path__ + "static/media/wather.ae7861ce5c2c53ff52d323d78f6596bc.svg";
export { ForwardRef as ReactComponent };